module.exports = __webpack_public_path__ + "static/media/cornerstone-community-church-logo.3f11c8e8.svg";